import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OneClickMaximumCapacityProvider } from '../../providers/builder/one-click-max-capacity.provider';
import { FieldInputNumberConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-input-number-config.interface';

@Injectable()
export class OneClickHandleMaximumCapacity implements OnFieldChanged {
  constructor() {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      const quantityField = form.config.find(
        (control) => control.name === OneClickBuilderField.Quantity,
      ) as FieldInputNumberConfig;
      if (quantityField.max instanceof OneClickMaximumCapacityProvider.MaximumCapacityBase) {
        quantityField.max.unitSubject.next();
      }
      if (quantityField.message instanceof OneClickMaximumCapacityProvider.MaximumCapacityBase) {
        quantityField.message.unitSubject.next();
      }
    }
  }
}
